import React, { FC } from 'react';
import clsx from 'clsx';
import Button from '../../atoms/button';
import styles from './StoreListItem.module.scss';
import { getSpecialHoursArray } from '@srcDS/hooks/useStoreLocator';

import { StoreListItemProps } from '@srcDS/components/organisms/findStoreDrawer/types';

const StoreListItem: FC<StoreListItemProps> = ({
  store,
  setShowDrawer,
  skuId,
  setSelectedStore,
  selectedStore,
  shouldHideClickCollect,
}) => {
  const availability = store.availability && store.quantity > 0;

  const handleSetSelectedStore = (data: { channel: { id: string; key: string }; skuId: string }): void => {
    setSelectedStore(data);
    setShowDrawer(false);
  };

  const specialHours = getSpecialHoursArray(store);

  return (
    <div className={styles.storeListItem}>
      <div>
        <h4 className={styles.storeListTitle}>{store.storeName}</h4>
        <div className={styles.storeListText}>
          <p>{store.address1}</p>
          <p>{`${store.address2 ? `${store.address2}, ` : ''}${store.city} ${store.state} ${store.postcode}`}</p>
          {store.todayHour && (
            <div className={styles.scheduleRow}>
              <span>Today's hours: </span>
              <span>{store.todayHour.time}</span>
            </div>
          )}
          {store?.['department-list'] && (
            <p className={styles.storeDepartment}>Department: {store?.['department-list']?.join(', ')}</p>
          )}
          {specialHours?.length
            ? specialHours.map((item, index) => (
                <div key={index} className={clsx(styles.scheduleRow, styles.specialHours)}>
                  <span>{item.name}: </span>
                  <span>{item.value}</span>
                </div>
              ))
            : null}
        </div>
        <div className={clsx(styles.stock, availability && styles.inStock)}>
          {availability ? (
            store.collect ? (
              <p>{shouldHideClickCollect ? 'Item is available' : 'Item is available for pickup'}</p>
            ) : (
              <p>{shouldHideClickCollect ? 'Item is available' : 'Item can be purchased in store'}</p>
            )
          ) : (
            <p>
              Item is <span>not</span> in stock
            </p>
          )}
        </div>
      </div>
      {!shouldHideClickCollect && availability && store.collect && (
        <div className={styles.storeListItemBtn}>
          {/*@ts-ignore*/}
          <Button
            variant="secondary"
            as="button"
            disabled={selectedStore?.channel?.id === store.id}
            onClick={() =>
              handleSetSelectedStore({
                channel: {
                  id: store.id,
                  key: store.key,
                },
                skuId,
              })
            }
          >
            {selectedStore?.channel?.id === store?.id ? 'Selected' : 'Select'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default StoreListItem;
